export default __webpack_public_path__ + "static/media/porc22.2dd7c5ba.png";